import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const globalsSlice = createSlice({
  name: "globals",
  initialState: {
    windowLoaded: false,
    experienceName: null as string | null,
    searchResults: null as any,
    jwtUserIdToken: null as string | null,
    userId: null as string | null,
    clientIp: null as string | null,
    userIdRan: false,
    sessionId: null as string | null,
    // Session starts have kept failing (#1733). Edge search stops waiting for
    // the session then, while AppLogic keeps retrying it in the background.
    sessionStartFailing: false,
    sessionTime: null as string | null,
    customUserId: (typeof localStorage !== "undefined"
      ? localStorage.getItem("korraCustomUserId")
      : null) as string | null,
  },
  reducers: {
    setWindowLoaded: (state, action: PayloadAction<boolean>) => {
      state.windowLoaded = action.payload;
    },
    setExperienceName: (state, action: PayloadAction<string>) => {
      state.experienceName = action.payload;
    },
    setSearchResults: (state, action: PayloadAction<any>) => {
      state.searchResults = action.payload;
    },
    setJWTUserIdToken: (state, action: PayloadAction<string | null>) => {
      state.jwtUserIdToken = action.payload;
    },
    setUserId: (state, action: PayloadAction<string>) => {
      state.userId = action.payload;
    },
    // Back to the state of a fresh load, so the next visitor of a public
    // portal gets their own anonymous session.
    clearUser: (state) => {
      state.userId = null;
      state.jwtUserIdToken = null;
      state.userIdRan = false;
      state.sessionId = null;
      state.sessionStartFailing = false;
    },
    setClientIp: (state, action: PayloadAction<string>) => {
      state.clientIp = action.payload;
    },
    setUserIdRan: (state, action: PayloadAction<boolean>) => {
      state.userIdRan = action.payload;
    },
    setSessionId: (state, action: PayloadAction<string>) => {
      state.sessionId = action.payload;
    },
    setSessionStartFailing: (state, action: PayloadAction<boolean>) => {
      state.sessionStartFailing = action.payload;
    },
    setSessionTime: (state, action: PayloadAction<string>) => {
      state.sessionTime = action.payload;
    },
    setCustomUserId: (state, action: PayloadAction<string>) => {
      state.customUserId = action.payload;
    },
  },
});

export const {
  setWindowLoaded,
  setExperienceName,
  setSearchResults,
  setJWTUserIdToken,
  setUserId,
  clearUser,
  setClientIp,
  setUserIdRan,
  setSessionId,
  setSessionStartFailing,
  setSessionTime,
  setCustomUserId,
} = globalsSlice.actions;
export default globalsSlice.reducer;
